import React, { useContext } from 'react';
import { Button, Spinner, mergeClasses } from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { useBannerActionsStyles } from './useBannerActionsStyles.styles';

export type BannerActionType = 'update' | 'refresh' | 'reset' | 'applying' | 'generating';
interface IBannerActionProps {
  classes: ReturnType<typeof useBannerActionsStyles>;
  type: BannerActionType;
  onRefresh?: () => void;
  onReset?: () => void;
}

const BannerAction: React.FC<IBannerActionProps> = React.memo(({
  classes,
  type,
  onRefresh,
  onReset,
}) => {
  const i18n = useContext(I18nContext) as I18nModel;

  if (type === 'update') {
    return (
      <Button
        className={mergeClasses(classes.WhiteButton, 'update-button')}
        onClick={onRefresh}
      >
        {i18n.getString(_TL_('Get recommendations'))}
      </Button>
    );
  } if (type === 'refresh') {
    return (
      <Button
        className={mergeClasses(classes.WhiteButton, 'refresh-button')}
        onClick={onRefresh}
      >
        {i18n.getString(_TL_('Refine'))}
      </Button>
    );
  } if (type === 'reset') {
    return (
      <Button
        className={mergeClasses(classes.TransparentButton, 'reset-button')}
        onClick={onReset}
      >
        {i18n.getString(_TL_('Remove assets'))}
      </Button>
    );
  } if (type === 'applying') {
    return (
      <Spinner
        className={mergeClasses(classes.ApplyingAction, 'progress-indicator')}
        size="tiny"
        label={{ className: classes.ApplyingActionLabel, children: i18n.getString(_TL_('Applying now')) }}
      />
    );
  } if (type === 'generating') {
    return (
      <Spinner
        className={mergeClasses(classes.ApplyingAction, 'progress-indicator')}
        size="tiny"
        label={{ className: classes.ApplyingActionLabel, children: i18n.getString(_TL_('Generating')) }}
      />
    );
  }
  return null;
});

export interface IBannerActionsProps {
  actions: BannerActionType[];
  onRefresh?: () => void;
  onReset?: () => void;
}

export const BannerActions: React.FC<IBannerActionsProps> = React.memo(({
  actions,
  onRefresh,
  onReset,
}) => {
  const classes = useBannerActionsStyles();

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className={mergeClasses(classes.root, 'banner-actions')}>
      {actions.map((action) => (
        <BannerAction
          key={action}
          classes={classes}
          type={action}
          onRefresh={onRefresh}
          onReset={onReset}
        />
      ))}
    </div>
  );
});
